import { ButtonProps } from "../../types/components.types";

// Define the Button component with props of type "ButtonProps"
const Button: React.FC<ButtonProps> = ({
  // Children: represents the content rendered inside the Button component.
  children,
  // The function that will be executed once the button is triggered.
  onClick,
  // specify the type of button. I have defaulted it to 'button'.
  type = "button",
  // The initial state of the button is set to false.
  disabled = false,
  testId,
}) => {
  return (
    <button
      className="btn"
      onClick={() => void onClick?.()}
      type={type}
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </button>
  );
};

export default Button;
